import { render } from "./ClientReportesProductosVendidos.vue?vue&type=template&id=7bfbf0b0&scoped=true"
import script from "./ClientReportesProductosVendidos.vue?vue&type=script&lang=js"
export * from "./ClientReportesProductosVendidos.vue?vue&type=script&lang=js"

import "./ClientReportesProductosVendidos.vue?vue&type=style&index=0&id=7bfbf0b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfbf0b0"]])

export default __exports__